/* DSL GA4 enhanced ecommerce events via dataLayer */
(function(){
  window.dataLayer = window.dataLayer || [];
  function dl(o){ window.dataLayer.push(o); }
  // view_item
  if (location.pathname.indexOf("/products/") === 0) {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) fetch("/products/" + m[1] + ".js").then(function(r){return r.json();}).then(function(p){
      dl({event: "view_item", ecommerce: {currency: "EUR", value: p.price/100, items: [{item_id: String(p.id), item_name: p.title, item_brand: p.vendor, item_category: p.type, price: p.price/100, quantity: 1}]}});
    });
  }
  // add_to_cart
  document.addEventListener("dsl:cart:add", function(e){
    var d = e.detail || {};
    dl({event: "add_to_cart", ecommerce: {currency: "EUR", value: (d.price||0)/100*(d.quantity||1), items: [{item_id: String(d.variant_id||d.product_id), item_name: d.product_title, price: (d.price||0)/100, quantity: d.quantity||1}]}});
  });
  // begin_checkout
  if (location.pathname === "/cart") {
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      if (c.item_count > 0) {
        dl({event: "begin_checkout", ecommerce: {currency: "EUR", value: c.total_price/100, items: c.items.map(function(i){return {item_id: String(i.variant_id), item_name: i.product_title, price: i.price/100, quantity: i.quantity};})}});
      }
    });
  }
  // search
  var qp = new URLSearchParams(location.search);
  var q = qp.get("q");
  if (q && location.pathname === "/search") dl({event: "search", search_term: q});
  // view_item_list — gehandled per collection
  if (location.pathname.indexOf("/collections/") === 0) {
    dl({event: "view_item_list", item_list_name: location.pathname.split("/")[2]});
  }
})();